import { SeriesId, SeriesResponse } from '@business/entities/series';
import { Endpoint } from '../endpoint';
import { CompanyId } from '@business/entities/companies';

export function fetchAllSeries(companyId: CompanyId, isCompact?: boolean) {
  return Endpoint.get<SeriesResponse[]>(`@makh/company-policy-series`, { params: { companyId, isCompact } });
}

export function fetchSeries(id: SeriesId) {
  return Endpoint.get<SeriesResponse>(`@makh/company-policy-series/adminscale/${id}`);
}

export function createSeries(data: Partial<SeriesResponse>) {
  return Endpoint.post<SeriesResponse>(`@makh/company-policy-series`, { data });
}

export function updateSeries(adminScaleId: SeriesId, data: Partial<SeriesResponse>) {
  return Endpoint.patch<SeriesResponse>(`@makh/company-policy-series/${adminScaleId}`, { data });
}

export function deleteSeries(adminScaleId: SeriesId) {
  return Endpoint.delete<void>(`@makh/company-policy-series/${adminScaleId}`);
}
